import { TemplateData, TemplateParams } from '.';

const achievementIndividualRequestGranted = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{individualAchievementsUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementIndividualRequestGrantedDescription}
        ${messages.achievementRequestSeeDetails}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementIndividualRequestGranted}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    individualAchievementsUrl: {
      label: messages.individualAchievementsLink,
      value: `${serverConfig.adminUrl}/achievements/individual`
    },
    optionalMessage: {
      label: messages.commonMessageFromAdmin,
      example: 'Here is your achievement.'
    },
    ...defaultPlaceholders
  },
  title: messages.achievementIndividualRequestGranted
});

export default achievementIndividualRequestGranted;
